const PodiumThirdPlaceIcon = () => {
  return (
    <svg
      width="157"
      height="101"
      viewBox="0 0 157 101"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M47.6293 13.3281L110.346 13.4284L131.375 25.3663H25.125L47.6293 13.3281Z"
        fill="#FFA23D"
      />
      <g filter="url(#filter0_d_10027_44961)">
        <path
          d="M25.125 25.3672H131.375V72.9965C131.375 74.1528 130.438 75.0901 129.281 75.0901H27.2186C26.0623 75.0901 25.125 74.1528 25.125 72.9965V25.3672Z"
          fill="url(#paint0_linear_10027_44961)"
        />
        <g filter="url(#filter1_d_10027_44961)">
          <rect
            x="66.2119"
            y="37.9961"
            width="24.5998"
            height="24.468"
            rx="2.0936"
            fill="#B0630E"
            shapeRendering="crispEdges"
          />
          <path
            d="M76.0997 53.3241C75.6001 53.3241 75.1551 53.2383 74.7648 53.0665C74.3767 52.8926 74.07 52.6539 73.8448 52.3506C73.6217 52.045 73.5069 51.6926 73.5002 51.2934H74.9589C74.9678 51.4607 75.0224 51.6079 75.1228 51.735C75.2254 51.8599 75.3614 51.9569 75.5309 52.0261C75.7005 52.0952 75.8912 52.1298 76.103 52.1298C76.3239 52.1298 76.519 52.0907 76.6885 52.0127C76.858 51.9346 76.9907 51.8264 77.0866 51.6882C77.1826 51.5499 77.2305 51.3904 77.2305 51.2097C77.2305 51.0268 77.1792 50.8651 77.0766 50.7246C76.9762 50.5819 76.8313 50.4704 76.6417 50.3901C76.4543 50.3098 76.2313 50.2696 75.9726 50.2696H75.3336V49.2057H75.9726C76.1911 49.2057 76.3841 49.1678 76.5514 49.092C76.7209 49.0161 76.8525 48.9113 76.9461 48.7775C77.0398 48.6414 77.0866 48.4831 77.0866 48.3024C77.0866 48.1307 77.0454 47.9801 76.9629 47.8508C76.8826 47.7192 76.7688 47.6166 76.6216 47.543C76.4766 47.4694 76.3071 47.4326 76.1131 47.4326C75.9168 47.4326 75.7373 47.4682 75.5744 47.5396C75.4116 47.6088 75.2811 47.708 75.183 47.8374C75.0849 47.9667 75.0325 48.1184 75.0258 48.2924H73.6373C73.644 47.8976 73.7567 47.5497 73.9752 47.2486C74.1938 46.9475 74.4882 46.7121 74.8585 46.5426C75.231 46.3709 75.6514 46.285 76.1198 46.285C76.5926 46.285 77.0064 46.3709 77.361 46.5426C77.7156 46.7144 77.9911 46.9463 78.1873 47.2385C78.3859 47.5285 78.484 47.8541 78.4818 48.2154C78.484 48.5991 78.3647 48.9191 78.1238 49.1756C77.8851 49.4321 77.574 49.5949 77.1904 49.6641V49.7176C77.6944 49.7823 78.0781 49.9574 78.3412 50.2429C78.6067 50.5261 78.7383 50.8807 78.736 51.3068C78.7383 51.6971 78.6256 52.0439 78.3981 52.3472C78.1728 52.6506 77.8617 52.8892 77.4647 53.0632C77.0677 53.2372 76.6127 53.3241 76.0997 53.3241ZM79.8643 48.4262V48.0716C79.8643 47.7526 79.9312 47.4705 80.0651 47.2251C80.1989 46.9776 80.3885 46.7835 80.6338 46.643C80.8814 46.5025 81.1713 46.4322 81.5037 46.4322C82.0122 46.4322 82.4125 46.5861 82.7047 46.8939C82.9991 47.2017 83.1463 47.5943 83.1463 48.0716V48.4262C83.1463 48.7429 83.0806 49.0239 82.949 49.2693C82.8174 49.5124 82.63 49.7042 82.3869 49.8447C82.1438 49.983 81.8538 50.0522 81.517 50.0522C81.0063 50.0522 80.6026 49.9005 80.3059 49.5972C80.0115 49.2916 79.8643 48.9013 79.8643 48.4262ZM80.6907 48.0716V48.4262C80.6907 48.7005 80.7598 48.928 80.8981 49.1087C81.0364 49.2871 81.2427 49.3763 81.517 49.3763C81.7869 49.3763 81.9877 49.2871 82.1193 49.1087C82.2531 48.928 82.32 48.7005 82.32 48.4262V48.0716C82.32 47.8039 82.2531 47.5775 82.1193 47.3924C81.9854 47.2073 81.7802 47.1147 81.5037 47.1147C81.236 47.1147 81.0331 47.2073 80.8948 47.3924C80.7587 47.5775 80.6907 47.8039 80.6907 48.0716Z"
            fill="white"
          />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_d_10027_44961"
          x="0.00184822"
          y="0.244036"
          width="156.496"
          height="99.969"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="12.5616" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.760784 0 0 0 0 0.411765 0 0 0 0 0.0235294 0 0 0 0.16 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_10027_44961"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_10027_44961"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_d_10027_44961"
          x="41.0888"
          y="12.8729"
          width="74.8459"
          height="74.7151"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="12.5616" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_10027_44961"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_10027_44961"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_10027_44961"
          x1="25.3611"
          y1="25.3672"
          x2="134.688"
          y2="67.0138"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DA770B" />
          <stop offset="1" stopColor="#B45F01" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default PodiumThirdPlaceIcon;
